<template>
	<div>
  <div class="grid">

    <div  class="col-12" v-if="stock_min" @click="goToInputs">
        <div :class="'st_bg_color'">
          <i class="pi pi-eye ml-2" ></i>
          <span> Atención: Hay Insumos por debajo del Stock Mínimo (Click para ir a Insumos)</span>          
        </div>        
    </div>

    <div class="col-12">

      <ResumedCharts />

    </div>

		<div class="col-3" >
			<div class="card" style="border-bottom: 5px solid #9A9A9A">
        
        <!--<h1>{{ countStatus(0)}}</h1>-->
        <h1>{{ no_init_orders.length }}</h1>

        <h3>SIN INICIAR</h3>
  
			</div>
		</div>
		<div class="col-3" >
			<div class="card" style="border-bottom: 5px solid #1C95C2">
        
        <!-- <h1>{{ countStatus(1)}}</h1> -->
        <h1>{{ process_orders.length }}</h1>

        <h3 @click="operatorNotify">EN PROCESO</h3>
  
			</div>
		</div>
		<div class="col-3" >
			<div class="card" style="border-bottom: 5px solid #EEC216">
        
        <!--<h1>{{ countStatus(2)}}</h1>-->
        <h1>{{ paused_orders.length }}</h1>

        <h3>EN PAUSA</h3>
  
			</div>
		</div>

    <!--#7E57C2 EN CALIDAD ? --->

		<div class="col-3" >
			<div class="card" style="border-bottom: 5px solid #66BB6A">
        
        <!--<h1>{{ countStatus(3)}}</h1>-->
        <h1>{{ quality_orders.length }}</h1>

        <h3>FINALIZADAS</h3>
  
			</div>
		</div>


  </div> 


  <TabView ref="tabview1">
    <TabPanel header="EN PROCESO">
          <div class="grid"> 
            <!-- 
            <OtiSquare v-for="order in orders.filter((order) =>{ return order.status == 1  || (order.machine_id.id == 1 && order.status !== 4)})" :key="order.id" :userGroup="opGroup" :order="order" /> 
            -->
            <OtiSquareAdmin v-for="order in orders.filter((order) =>{ return order.status == 1  || ((order.machine_id && order.machine_id.id == 1) && order.status !== 4)})" :key="order.id" :userGroup="opGroup" :order="order" /> 
          </div>
      </TabPanel>
      <!-- <TabPanel header="ASIGNADAS">
          <div class="grid"> <OtiSquare v-for="order in orders.filter((order) => order.status == 4)" :key="order.id" :userGroup="opGroup" :order="order" /> </div>
      </TabPanel>-->
      <TabPanel header="SIN ASIGNAR / SIN INICIAR">
          <div class="grid"> 
            <!--
            <OtiSquare v-for="order in orders.filter((order) => {return order.status == 0 && order.machine_id.id !== 1})" :key="order.id" :userGroup="opGroup" :order="order" /> 
            -->
            <OtiSquareAdmin v-for="order in orders.filter((order) => {return order.status == 0 && (! order.machine_id || order.machine_id.id !== 1)})" :key="order.id" :userGroup="opGroup" :order="order" /> 
          </div>
      </TabPanel> 
      <TabPanel header="EN PAUSA">
          <div class="grid"> <OtiSquareAdmin v-for="order in orders.filter((order) => { return order.status == 5 || order.status == 2})" :key="order.id" :userGroup="opGroup" :order="order" /> </div>
      </TabPanel>
      <TabPanel header="EN CALIDAD">
          <div class="grid"> <OtiSquareAdmin v-for="order in orders.filter((order) => order.status == 3)" :key="order.id" :userGroup="opGroup" :order="order" /> </div>
      </TabPanel>
      <TabPanel header="FINALIZADAS">
          <div class="grid"> <OtiSquareAdmin v-for="order in orders.filter((order) => order.status == 4)" :key="order.id" :userGroup="this.opGroup" :order="order" /> </div>
      </TabPanel>
      
      <TabPanel header="TODAS" style="background-color: #F5F5F5">
          <div class="grid"> <OtiSquareAdmin v-for="order in orders" :key="order.id" :userGroup="opGroup" :order="order" /> </div>
      </TabPanel>
  </TabView>


  </div>

</template>

<script>
import CrudService from "./../../services/crud.service.js" 
import OtiSquareAdmin from "./OtiSquareAdmin.vue";
import ResumedCharts from "./ResumedCharts.vue";

export default {
  emits: ['operator-notify'],
  props: ['opGroup'],
  data() {
    return {
      orders: [],
      process_orders: [],
      no_init_orders: [],
      paused_orders: [],
      quality_orders: [],
      stock_min: false
    }
  },
  components: {
    OtiSquareAdmin,
    ResumedCharts
  },
	computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentGroup() {
      return this.$store.state.auth;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    }
    this.getOrders();
    this.checkStockMin();
  }, 
  methods: {
    pushItemOrder(order) {
      let item_add = order.productos.filter((item) => item.assigned == 1 && (item.status_flujo==1 || item.status_flujo=='1'))
      if (item_add && item_add.length > 0) {
        order.productos_filter = item_add;
        this.process_orders.push(order);
      }
      item_add = order.productos.filter((item) => item.assigned == 1 && (item.status_flujo==2 || item.status_flujo=='2'))
      if (item_add && item_add.length > 0) {
        order.productos_filter = item_add;
        this.paused_orders.push(order);
      }
      item_add = order.productos.filter((item) => item.assigned == 1 && (item.status_flujo==3 || item.status_flujo=='3'))
      if (item_add && item_add.length > 0) {
        order.productos_filter = item_add.producto;
        this.quality_orders.push(order);
      }
      item_add = order.productos.filter((item) => item.assigned == 1 && (item.status_flujo==0 || item.status_flujo=='0'))
      if (item_add && item_add.length > 0) {
        order.productos_filter = item_add;
        this.no_init_orders.push(order);
      }
    },
    goToInputs() {
      this.$router.push('insumos');
    },
    countStatus(status) {
      return this.orders.filter((order) => order.status == status).length;
    },
    getOrders() {
        CrudService.getCRUD("orden", "orden").then((data) => {
          this.orders = data
          data.forEach((item) => {
            this.pushItemOrder(item);
          });
          console.log('this.orders...')
          console.log(this.orders)
        });
    },
    checkStockMin() {
        CrudService.getCRUD("insumos", "verify-stockmin").then((data) => (this.stock_min = data.stock_min));
    },
    operatorNotify(){
      //console.log('notifying...')
      this.$emit('operator-notify', true);
    }

  }

}
</script>

<style scoped>
  .st_bg_color { 
    font-size: 1.3rem;
    height: 2.5rem;
    border: 1px solid #ff99005b;
    background-color: #ff99005b;
    & >div i {
        color: #FF9800;
    }
  }

    .motiveButton {
        
        font-size: 1.8rem;
        text-transform: uppercase;
        margin: 1%;
        background: #ff99005b;
        color: black;
        border: 1px solid #ff99005b;
        &:hover {
            background: #ff9900;
            color: black;
            border: 1px solid #ff9900;
        }
    }
</style>